import React from 'react'
import MealReport from '../../../components/organisms/admin/report/MealReport'

type Props = {}

const MealReportPage = (props: Props) => {
  return (
    <MealReport />
  )
}

export default MealReportPage